import React from "react";
import { AccordionTitleView, DropDown, InputText } from "../../../components";
import Grid from "semantic-ui-react/dist/commonjs/collections/Grid/Grid";
import { InputNumber } from "../../../components/InputText/InputNumber";
import { useForm } from "react-hook-form";
import { Accordion, AccordionContent, AccordionTitle } from "semantic-ui-react";

const IngredientTransportDetails: React.FC = () => {
  const { control, register } = useForm();
  return (
    <div>
      <Accordion>
        <AccordionTitle
          active={true}
          onClick={() => {
            return true;
          }}
        >
          <AccordionTitleView accordionEnabled={true} title={"Ingredient Transport Details"} />
        </AccordionTitle>
        <AccordionContent active={true} className="mb-3">
          <Grid>
            <Grid.Row divided>
              <Grid.Column computer={8} tablet={16} mobile={16}>
                <Grid columns={4}>
                  <Grid.Row>
                    <Grid.Column>
                      <p className="textLabel mb-0">From </p>
                      <p className="textLabel">{1}</p>
                    </Grid.Column>
                    <Grid.Column>
                      <p className="textLabel mb-0">To</p>
                      <p className="textLabel">{"ml"}</p>
                    </Grid.Column>
                    <Grid.Column>
                      <p className="textLabel mb-0">Transport Type</p>
                      <p className="textLabel">{"L00"}</p>
                    </Grid.Column>
                    <Grid.Column>
                      <p className="textLabel mb-0">Distance</p>
                      <p className="textLabel">{"PD00"}</p>
                    </Grid.Column>
                    <Grid.Column>
                      <p className="textLabel mb-0">Weight</p>
                      <p className="textLabel">{"PD00"}</p>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
              <Grid.Column computer={8} tablet={16} mobile={16}>
                <Grid columns={4}>
                  <Grid.Row>
                    <Grid.Column>
                      <InputText
                        register={register}
                        labelName={"From"}
                        placeholder="From"
                        name="from"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <InputText register={register} labelName={"To"} placeholder="To" name="to" />
                    </Grid.Column>
                    <Grid.Column>
                      <DropDown
                        labelName={"Transportation Type"}
                        currentData={[]}
                        defaultValue={"customGridColomnTyp"}
                        customGridColumn={"customGridColomnTyp"}
                        handleChangeState={(e: any, { value }: any) => {}}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <InputNumber
                        labelName={"Distance"}
                        placeholder="Distance"
                        name="distance"
                        control={control}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <InputText
                        register={register}
                        labelName={"Weight"}
                        placeholder="Weight"
                        name="weight"
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </AccordionContent>
      </Accordion>
    </div>
  );
};

export default IngredientTransportDetails;
